import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'

// BUILD VERSION: Helps identify which code is running (cache debugging)
// This timestamp is baked in at build time via vite.config.ts define
console.log('[App] Build version:', __BUILD_TIME__);
console.log('[App] HIPAA Session Timeout v2.0 - Race condition fix deployed');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
